import { RefObject, useEffect, useRef } from "react";

/** There is a race condition where customer.io may run before the WebPlusShippingAd component has completed its
 * internal requests to get user plus data. In this circumstance, the customer.io ad would render and then the plus
 * ad would render below it with incorrect design. This mutation observer will update the state to indicate that the
 * customer.io ad has content and prevent the WebPlusShippingAd from rendering.
 *
 * I wouldn't recommend using this unless you absolutely have to. This works around shortcomings in the WebPlusShippingAd
 * component
 */
export default ({
  targetRef,
  onMutation,
}: {
  targetRef: RefObject<HTMLElement>;
  onMutation: (mutated: boolean) => void;
}) => {
  const mutationHandler: MutationCallback = (mutationList) => {
    if (mutationList.some((mutation) => mutation.target.hasChildNodes()))
      onMutation(true);
  };

  const mutationObserverRef = useRef(new MutationObserver(mutationHandler));

  useEffect(() => {
    if (mutationObserverRef.current && targetRef.current)
      mutationObserverRef.current.observe(targetRef.current, {
        childList: true,
      });
  }, []);
};
